import styled from "styled-components";

export const StyledBox = styled.div`
    ${({ customStyle }) => customStyle && customStyle};
`;